var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronBarLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chevron-bar-left",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.381,
    height: 21.664,
    viewBox: "0 0 12.381 21.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M21.153,6.345a.774.774,0,0,1,0,1.1L15.51,13.082l5.644,5.642a.775.775,0,1,1-1.1,1.1l-6.19-6.19a.774.774,0,0,1,0-1.1l6.19-6.19a.774.774,0,0,1,1.1,0ZM9.774,2.25A.774.774,0,0,0,9,3.024V23.14a.774.774,0,0,0,1.547,0V3.024A.774.774,0,0,0,9.774,2.25Z",
    transform: "translate(-9 -2.25)",
    fill: "#329bc9",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBarLeft);
export default __webpack_public_path__ + "static/media/chevron-bar-left.dfaab23d6660c2c1a38dd7a02d3a045b.svg";
export { ForwardRef as ReactComponent };